/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Preset_Manager_Import_Failed_ToastInputs */

const en_preset_manager_import_failed_toast = /** @type {(inputs: Preset_Manager_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to import presets: ${i?.error}`)
};

const fr_preset_manager_import_failed_toast = /** @type {(inputs: Preset_Manager_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'importation des presets : ${i?.error}`)
};

const de_preset_manager_import_failed_toast = /** @type {(inputs: Preset_Manager_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voreinstellungen konnten nicht importiert werden: ${i?.error}`)
};

const it_preset_manager_import_failed_toast = /** @type {(inputs: Preset_Manager_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile importare i preset: ${i?.error}`)
};

const ru_preset_manager_import_failed_toast = /** @type {(inputs: Preset_Manager_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать пресеты: ${i?.error}`)
};

const es_preset_manager_import_failed_toast = /** @type {(inputs: Preset_Manager_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al importar ajustes preestablecidos: ${i?.error}`)
};

const zh_cn2_preset_manager_import_failed_toast = /** @type {(inputs: Preset_Manager_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入预设失败：${i?.error}`)
};

const ja_preset_manager_import_failed_toast = /** @type {(inputs: Preset_Manager_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プリセットのインポートに失敗しました: ${i?.error}`)
};

const hi_preset_manager_import_failed_toast = /** @type {(inputs: Preset_Manager_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रीसेट आयात करने में विफल: ${i?.error}`)
};

const pt_pt2_preset_manager_import_failed_toast = /** @type {(inputs: Preset_Manager_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao importar predefinições: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to import presets: {error}" |
*
* @param {Preset_Manager_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_failed_toast = /** @type {((inputs: Preset_Manager_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_import_failed_toast(inputs)
	if (locale === "de") return de_preset_manager_import_failed_toast(inputs)
	if (locale === "it") return it_preset_manager_import_failed_toast(inputs)
	if (locale === "ru") return ru_preset_manager_import_failed_toast(inputs)
	if (locale === "es") return es_preset_manager_import_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_import_failed_toast(inputs)
	if (locale === "ja") return ja_preset_manager_import_failed_toast(inputs)
	if (locale === "hi") return hi_preset_manager_import_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_import_failed_toast(inputs)
	return en_preset_manager_import_failed_toast(inputs)
});